import { useSelector } from 'react-redux'
import { getThemeColors } from '../configs/theme.colors'

/**
 * Hook to get theme colors based on current theme mode
 * @returns {Object} Color object for the current theme
 */
export const useThemeColors = () => {
    const mode = useSelector(state => state.theme?.mode || 'light')
    const colors = getThemeColors(mode)
    
    // Map to expected property names for backward compatibility
    return {
        primary: colors.primary,
        primaryText: colors.primaryText || colors.primary, // Lighter blue for text/links in dark mode
        warning: colors.warning,
        warningText: colors.warningText,
        warningBackground: colors.warningBackground,
        success: colors.success,
        error: colors.error,
        text: colors.text,
        secondaryText: colors.secondaryText,
        txtWhite: colors.txtWhite,
        background: colors.mainBg, // White in light mode, dark bg in dark mode
        mainBg: colors.mainBg,
        secondBg: colors.secondBg,
        nestedCardBg: colors.nestedCardBg,
        groupCardBg: colors.groupCardBg,
        disabled: colors.disabled,
        info: colors.info,
        borderColor: colors.borderColor,
        boxShadow: colors.boxShadow,
        hoverBg: colors.hoverBg,
        breadcrumbText: colors.breadcrumbText,
    }
}
